import jwtDecode from "jwt-decode";

const AuthProvider = {
    login: ({ username, password }) => {
        const request = new Request(
            `${process.env.REACT_APP_API_ENTRYPOINT}/authentication_token`,
            {
                method: "POST",
                body: JSON.stringify({ username: username, password: password }),
                headers: new Headers({ "Content-Type": "application/json" }),
            }
        );
        return fetch(request)
            .then((response) => {
                if (response.status < 200 || response.status >= 300) {
                    throw new Error(response.statusText);
                }
                return response.json();
            })
            .then(({ token }) => {
                const decodedToken = jwtDecode(token);
                localStorage.setItem("token", token);
                localStorage.setItem("roles", decodedToken.roles);
            });
    },
    logout: () => {
        localStorage.removeItem("token");
        localStorage.removeItem("roles");
        return Promise.resolve();
    },
    checkAuth: () => {
        try {
            if (
                !localStorage.getItem("token") ||
                new Date().getTime() / 1000 >
                jwtDecode(localStorage.getItem("token"))?.exp
            ) {
                return Promise.reject();
            }
            return Promise.resolve();
        } catch (e) {
            // override possible jwtDecode error
            return Promise.reject();
        }
    },
    checkError: (err) => {
        if ([401, 403].includes(err?.status || err?.response?.status)) {
            localStorage.removeItem("token");
            return Promise.reject();
        }
        return Promise.resolve();
    },
    getPermissions: () => {
        const roles = localStorage.getItem('roles');
        return roles ? Promise.resolve(roles) : Promise.reject();
    }
};

export default AuthProvider;